(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('AgendaService', AgendaService);

  AgendaService.$inject = [
    '$uibModal',
    '$q',
    'TarefasService',
    'TarefaObjectService',
    'MessagesService'
  ];

  function AgendaService($uibModal, $q, TarefasService, TarefaObjectService, MessagesService) {
    var service = {
      openModal: OpenModal,
      getTasksByDate: GetTasksByDate,
      getTasksByPeriod: GetTasksByPeriod,
      prepareDates: PrepareDates,
      taskDetails: TaskDetails
    };
    return service;

    function OpenModal(date) {
      $uibModal.open({
        controller: 'AgendaCtrl',
        controllerAs: 'agenda',
        resolve: {
          date: function() {
            return date || moment();
          }
        },
        templateUrl: 'views/painel_propriedade/modal_agenda.html',
        windowClass: 'modal-agenda'
      });
    }

    function GetTasksByDate() {
      return $q(function(resolve) {
        var dates = [];

        // TarefasService.list({
        //   tipo: {
        //     tipo: 'geral',
        //   },
        //   dataInicial: moment(date).format(MOMENT_DATE_ENGLISH_FORMAT),
        //   dataFinal: moment(date).format(MOMENT_DATE_ENGLISH_FORMAT)
        // }).then(function(tarefas) {
        //   dates = service.prepareDates(tarefas.data);
        //   resolve(dates);
        // }).catch(reject);
        var day = moment();

        for (var i = 0; i < 10; i++) {
          var amount = Math.random() * 10;
          var random = Math.random();
          for (var t = 0; t < amount; t++) {
            dates.push({
              acao: 'Tarefa de colheita',
              created_at: moment(day).subtract(2, 'day').toDate(),
              data_final: day.format(MOMENT_DATE_ENGLISH_FORMAT),
              data_inicial: day.format(MOMENT_DATE_ENGLISH_FORMAT),
              eliminado: false,
              finalizado_em: null,
              glebas: [
                {
                  gleba: {
                    id: 130,
                    area_total: "48.73",
                    descricao: "DIAS",
                    tem_kml: true
                  }
                }
              ],
              id: Math.round(Math.random() * 100),
              insumo: null,
              observacoes: null,
              parametros: null,
              pontos: [],
              propriedade: {
                id: 14,
                descricao: "AG. LUIZA"
              },
              responsavel: {
                id: 1111,
                cor: "182BB6",
                email: "mateus.nava@agro1.inf.br",
                nome: "MATEUS",
                nome_completo: "MATEUS LUIS NAVA",
                nr_dias_cons_tit_web: 5,
                token: "c608cdc460eaa1dc5bb4ac3f9dfabdd53891734c0bb972dd1ab9ac76f6d743c3",
                utiliza_mobile: true
              },
              safra: {
                id: 16,
                descricao: "2017/2018"
              },
              status: random > 0.66 ? "finalizado" : random > 0.33 ? "pendente" : "andamento",
              tipo: "geral",
              usuario: {
                id: 1111,
                cor: "182BB6",
                email: "mateus.nava@agro1.inf.br",
                nome: "MATEUS",
                nome_completo: "MATEUS LUIS NAVA",
                nr_dias_cons_tit_web: 5,
                token: "c608cdc460eaa1dc5bb4ac3f9dfabdd53891734c0bb972dd1ab9ac76f6d743c3",
                utiliza_mobile: true
              }
            });
          }
          day.add(1, 'day');
        }

        resolve(service.prepareDates(dates));
      });
    }

    function GetTasksByPeriod() {
      return $q(function(resolve, reject) {
        var dates = [];

        TarefasService.list({
          tipo: {
            tipo: 'geral'
          }
        }).then(function(tarefas) {
          /*eslint no-console: 0*/
          console.log(tarefas);
          resolve(dates);
        }).catch(reject);

      });
    }

    function PrepareDates(tarefas) {
      var container = tarefas.reduce(function(dates, current) {
        current.status = TarefasService.getTarefaStatus(current.status);
        current.tipo = TarefaObjectService.getTarefaTipo(current.tipo);
        current.tempoDecorrido = moment().diff(current.updated_at, 'days');

        if (current.data_inicial in dates) {
          dates[current.data_inicial].tasks.push(current);
        } else {
          dates[current.data_inicial] = {
            date: current.data_inicial,
            tasks: [current]
          };
        }
        return dates;
      }, {});
      var result = Object.values(container);

      return result;
    }

    function TaskDetails(task) {
      return $q(function(resolve, reject) {
        TarefasService.get(task.id).then(function(tarefa) {
          task.imagens = tarefa.imagensOrigem.concat(tarefa.imagens);
          task.glebas = tarefa.glebas.map(function(gleba) {
            return gleba.gleba;
          });
          task.observacao = tarefa.observacao;
          resolve(task);
        }, function() {
          MessagesService.alert('Falha ao recuperar dados da tarefa, tente novamente.');
          reject();
        });
      });
    }
  }

}());
